<template>
    <div>
        <template v-for="(rowAction, index) in rowActions" :key="index">
            <Tooltip v-if="rowAction.visible?.(props)">
                <template v-slot:title>{{ rowAction.text?.() }}</template>
                <Button v-bind="rowAction.bind" @click="() => rowAction.onClick?.(props)">
                    <span v-if="rowAction.showText?.()">{{ rowAction.text?.() }}</span>
                </Button>
            </Tooltip>
        </template>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { Button, Tooltip } from "ant-design-vue";

export default defineComponent({
    components: {
        Button,
        Tooltip,
    },
    props: {
        rowActions: {},
        column: {},
        record: {},
        index: {},
    },
    setup(props) {
        return { props };
    },
});
</script>
